module.exports = __webpack_public_path__ + "static/media/tc.a9bfa08f.svg";